import { render, staticRenderFns } from "./Stands.vue?vue&type=template&id=2c7e9b26&"
import script from "./Stands.vue?vue&type=script&lang=js&"
export * from "./Stands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports